<template>
  <div>
    <LoaderApp v-if="loading"></LoaderApp>
    <div v-else>
      <div class="card">
        <div class="no-gutters row">
          <div class="col-12">
            <div class="widget-content" style="border-bottom: 1px solid rgba(0,0,0,0.125);">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-3 d-none d-md-block">
                  <h4 class="m-0 widget-heading">Cliente:</h4>
                </div>
                <div class="widget-content-left">
                  <h4 class="m-0 widget-heading text-secondary">{{cliente.nombre}}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content  py-1">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">N° doc/CUIT:</p>
                </div>
                <div class="widget-content-left">
                  <p class="text-success m-0 widget-heading">{{cliente.numero_documento | cuil}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4" v-if="user.tipo === 'Administrador'">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">IVA:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{cliente.responsabilidad_iva.descripcion}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Ultima compra:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{cliente.ultima_compra | moment("DD/MM/YYYY")}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Saldo:</p>
                </div>
                <div class="widget-content-left">
                  <p class="text-danger m-0 widget-heading">${{cliente.saldo | numFormat('0,0.00')}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4" v-if="user.tipo === 'Administrador'">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Lista:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">
                    {{cliente.lista.descripcion}}(
                    <span class="text-danger">{{cliente.lista.porcentaje}}%</span>)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4" v-if="user.tipo === 'Administrador'">
            <div class="widget-content  py-1">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Domicilio:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{cliente.domicilio}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 col-xl-4" v-if="user.tipo === 'Administrador'">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Localidad:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{cliente.localidad}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4" v-if="user.tipo === 'Administrador'">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Codigo postal:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{cliente.codigo_postal}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xl-4" v-if="user.tipo === 'Administrador'">
            <div class="widget-content py-1 py-md-2">
              <div class="widget-content-wrapper">
                <div class="widget-content-right ml-0 mr-2">
                  <p class="m-0 widget-heading">Teléfono:</p>
                </div>
                <div class="widget-content-left">
                  <p class="m-0 widget-heading">{{cliente.telefono}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="card p-2 mt-2 col-md-6">
          <div class="card-header">
            <h4 class="text-center">Historial</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 text-center">
                <button @click="abrirModalCuenta = true" class="btn btn-info mb-2">Imprimir cuenta corriente</button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <ul class="list-group list-group-flush mb-3 detail">
                  <li
                    class="list-group-item hoverable"
                    v-for="movimiento in cliente.movimientos"
                    :key="movimiento.id"
                    @click="ver(movimiento)"
                  >
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper row">
                        <div class="widget-content-left col-6">
                          <h6
                            class="widget-heading my-0"
                            :class="movimiento.anulado === 0 ? ' text-primary' : ' text-muted' "
                          >{{movimiento.denominacion}} <span class="text-danger" v-if="movimiento.anulado === 1">ANULADO</span></h6>
                          <span class="widget-subheading opacity-10 w-100">Fecha: <span class="text-alternate">{{movimiento.created_at | moment("DD/MM/YYYY")}}</span></span>
                        </div>
                        <div class="widget-content-right col-6 text-right">
                          <h5
                            class="widget-heading font-weight-bold"
                            :class="movimiento.denominacion == 'PUNITORIOS' ? 'text-danger' : 'text-success'"
                          >${{movimiento.total | numFormat('0,0.00')}}</h5>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card p-2 mt-2">
        <div class="row">
          <div class="col-md-2">
            <button
              class="btn btn-info btn-block mb-2 mb-md-0"
              type="button"
              @click="$router.go(-1)"
            >Volver</button>
          </div>
          <div class="col-md-2 offset-md-6" v-if="user.tipo === 'Administrador'">
            <router-link
              class="btn btn-block btn-warning text-white mb-2 mb-md-0"
              :to="{name:'EditarCliente', params:{id:cliente.id}}"
            >Editar</router-link>
          </div>
          <div class="col-md-2" v-if="user.tipo === 'Administrador'">
            <button
              class="btn btn-danger btn-block mb-2 mb-md-0"
              type="button"
              @click="eliminarCliente()"
            >Eliminar</button>
          </div>
        </div>
      </div>
      <ModalDetalleComprobante v-if="abrirModalDetalle" :movimiento="movimientoSeleccionado" @cerrarDetalleComprobante="cerrarModal"></ModalDetalleComprobante>
      <modalCuentasCliente v-if="abrirModalCuenta" :cliente="cliente" @cerrarCuentaCliente="abrirModalCuenta = false"></modalCuentasCliente>
    </div>
  </div>
</template>
<script>
import Cliente from "@/models/cliente";
import Swal from "sweetalert2";
import axios from "axios";
import LoaderApp from "@/components/loaders/LoaderApp";
import ModalDetalleComprobante from '@/components/views/comprobantes/ModalDetalleComprobante';
import modalCuentasCliente from '@/components/views/reportes/modalCuentasCliente';
import { mapGetters } from "vuex";
export default {
  name: "VerCliente",
  components: {
    LoaderApp,
    ModalDetalleComprobante,
    modalCuentasCliente,
  },
  data() {
    return {
      cliente: new Cliente(null, "", "", null, "", null),
      loading: true,
      abrirModalDetalle: false,
      abrirModalCuenta: false,
      movimientoSeleccionado: {}
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user"
    })
  },
  mounted() {
    this.cliente.id = this.$route.params.id;
    this.getCliente();
  },
  methods: {
    getCliente() {
      this.loading = true;
      axios
        .get("/clientes/" + this.cliente.id)
        .then(res => {
          if (res.data.success) {
            this.cliente = res.data.cliente;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    eliminarCliente() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar ${this.cliente.nombre} de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/clientes/" + this.cliente.id)
            .then(res => {
              Swal.fire(
                "Eliminado",
                `${res.data.cliente.nombre} se ha eliminado con éxito.`,
                "success"
              );
              this.$router.push({ name: "ListarClientes" });
            })
            .catch(err => console.log(err))
            .finally(() => (this.loading = false));
        }
      });
    },
    ver(movimiento) {
      if (movimiento.tipo === 'Venta') {
        if (movimiento.denominacion.charAt(0) === 'R') {
          Swal.fire({
            title: '¿Que deseas hacer con el remito ' + movimiento.denominacion + '?',
            showDenyButton: true,
            showCancelButton: true,
            cancelButtonColor: '#6e7881',
            denyButtonColor: '#3ac47d',
            confirmButtonText: 'Facturar',
            denyButtonText: `Imprimir`,
            cancelButtonText: 'Cancelar',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.facturarRemito(movimiento)
            } else if (result.isDenied) {
              window.open(
                `${axios.defaults.baseURL}/imprimir/comprobante/${movimiento.id}`
              );
            }
          })
        } else {
          if(movimiento.anulado === 1){
            Swal.fire({
              title: '¿Que acción desea realizar?',
              showDenyButton: true,
              showCancelButton: true,
              cancelButtonColor: '#6e7881',
              denyButtonColor: '#3ac47d',
              confirmButtonText: 'Imprimir factura',
              denyButtonText: `Imprimir nota de crédito`,
              cancelButtonText: 'Cancelar',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                window.open(
                  `${axios.defaults.baseURL}/imprimir/comprobante/${movimiento.id}`
                );
              } else if (result.isDenied) {
                window.open(
                  `${axios.defaults.baseURL}/imprimir/nota-credito/${movimiento.id}`
                );
              }
            })
          }else{
            window.open(
              `${axios.defaults.baseURL}/imprimir/nota-credito/${movimiento.id}`
            );
          }
        }
      }
    },
    facturarRemito(movimiento) {
      this.loading = true;
      axios.get('movimiento/facturar-remito/' + movimiento.id).then((response) => {
        Swal.fire({
          icon: "success",
          title: "Éxito",
          text: `${response.data.movimiento.denominacion} se guardó con éxito.`,
        });
        this.$refs['datatable'].update()
      })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido guardar correctamente`,
          });

        })
        .finally(() => this.loading = false)
    }
  }
};
</script>
